<template>
  <!-- Revit导出设置 -->
  <div class="revitSet">
    <el-main class="main">
      <router-view></router-view>
    </el-main>
  </div>
</template>

<script>
export default {
  name: "RevitSet",
  components: {},
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.revitSet {
  height: 100%;

  .main {
    height: 100%;
    padding: 0;
  }
}
</style>

<style lang="scss">
.dialogRevitAddSet {
  .el-dialog {
    border-radius: 4px !important;
  }

  .el-dialog__header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .el-dialog__title {
      font-family: "PingFang SC";
      font-weight: 400;
      font-size: 18px;
      line-height: 25px;
      color: var(--key-color);
    }

    .el-dialog__headerbtn {
      position: relative;
      top: 0 !important;
      right: 0 !important;
    }
  }

  .el-dialog__body {
    min-height: 250px;
    padding: 20px 30px 50px !important;
  }

  .el-dialog__footer {
    padding: 7px 15px 8px !important;
  }
}

.dialogRevitImportFail {
  .el-dialog {
    border-radius: 4px !important;
  }

  .el-dialog__header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .el-dialog__title {
      font-family: "PingFang SC";
      font-weight: 400;
      font-size: 18px;
      line-height: 25px;
      color: var(--key-color);
    }

    .el-dialog__headerbtn {
      position: relative;
      top: 0 !important;
      right: 0 !important;
    }
  }

  .el-dialog__body {
    min-height: 250px;
    padding: 20px 30px 20px !important;
  }

  .el-dialog__footer {
    padding: 7px 15px 8px !important;
  }
}
</style>
